import React from "react";
import styles from './horizontalTab.module.scss';
import {HorizontalTabsDto} from "../../../dtos";
import {useDispatch} from "react-redux";
import {changeActiveUnlinkTab} from "../../../store/actionCreators/promotionsItemsCreators";

interface Props {
    tab: HorizontalTabsDto,
    isActive: boolean,
}

export const HorizontalTab = (props: Props) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(changeActiveUnlinkTab(props.tab.name))
    }
    return (
        <div className={`${styles.tab_wrapper} ${props.isActive ? styles.active : ''}`} onClick={onClick}>
            {props.tab.name}
        </div>
    )
};